import { BarceloComponent } from "components-utils";

const AllContent = {
  bwdWidgetSocial: BarceloComponent({
    selector: ".bwd-widget-social, .bwd-widget-social-dl-id",
    path: "bwd/content/bwd-widget-social/js/bwd-widget-social",
  }),

  bwdContactForm: BarceloComponent({
    selector: ".bwd-contact-form, .bwd-contact-form-dl-id, [data-wedding-contact-form-url]",
    path: "bwd/content/bwd-contact-form/js/bwd-contact-form",
    ignoreViewport: true,
  }),

  bwdArticleSwiper: BarceloComponent({
    selector: ".bwd-article-swiper, .bwd-article-swiper-dl-id",
    path: "bwd/content/bwd-article-swiper/js/bwd-article-swiper",
  }),

  bwdCommitment: BarceloComponent({
    selector: ".bwd-commitment, .bwd-commitment-dl-id",
    path: "bwd/content/bwd-commitment/js/bwd-commitment",
  }),

  bwdComparatorCard: BarceloComponent({
    selector: ".bwd-comparator-card, .bwd-comparator-card-dl-id",
    path: "bwd/content/bwd-comparator-card/js/bwd-comparator-card",
  }),

  bwdDestComparator: BarceloComponent({
    selector: ".bwd-dest-comparator, .bwd-dest-comparator-dl-id",
    path: "bwd/content/bwd-dest-comparator/js/bwd-dest-comparator",
  }),

  bwdDestinationFeature: BarceloComponent({
    selector: ".bwd-destination-feature, .bwd-destination-feature-dl-id",
    path: "bwd/content/bwd-destination-feature/js/bwd-destination-feature",
  }),

  bwdDestinationFeatures: BarceloComponent({
    selector: ".bwd-destination-features, .bwd-destination-features-dl-id",
    path: "bwd/content/bwd-destination-features/js/bwd-destination-features",
  }),

  bwdFaqs: BarceloComponent({
    selector: ".bwd-faqs, .bwd-faqs-dl-id",
    path: "bwd/content/bwd-faqs/js/bwd-faqs",
  }),

  bwdFeature: BarceloComponent({
    selector: ".bwd-feature, .bwd-feature-dl-id",
    path: "bwd/content/bwd-feature/js/bwd-feature",
  }),

  bwdFeaturesBanner: BarceloComponent({
    selector: ".bwd-features-banner, .bwd-features-banner-dl-id",
    path: "bwd/content/bwd-features-banner/js/bwd-features-banner",
  }),

  bwdHero: BarceloComponent({
    selector: ".bwd-hero, .bwd-hero-dl-id",
    path: "bwd/content/bwd-hero/js/bwd-hero",
  }),

  bwdHotelDetail: BarceloComponent({
    selector: ".bwd-hotel-detail, .bwd-hotel-detail-dl-id",
    path: "bwd/content/bwd-hotel-detail/js/bwd-hotel-detail",
  }),

  bwdLauncher: BarceloComponent({
    selector: ".bwd-launcher, .bwd-launcher-dl-id",
    path: "bwd/content/bwd-launcher/js/bwd-launcher",
  }),

  bwdMap: BarceloComponent({
    selector: ".bwd-map, .bwd-map-dl-id",
    path: "bwd/content/bwd-map/js/bwd-map",
  }),

  bwdMenu: BarceloComponent({
    selector: ".bwd-menu, .bwd-menu-dl-id",
    path: "bwd/content/bwd-menu/js/bwd-menu",
  }),

  bwdMultilaunchers: BarceloComponent({
    selector: ".bwd-multi-launchers, .bwd-multi-launchers-dl-id",
    path: "bwd/content/bwd-multi-launchers/js/bwd-multi-launchers",
  }),

  bwdPackagesBanner: BarceloComponent({
    selector: ".bwd-packages-banner, .bwd-packages-banner-dl-id",
    path: "bwd/content/bwd-packages-banner/js/bwd-packages-banner",
  }),

  bwdRatingsBanner: BarceloComponent({
    selector: ".bwd-ratings-banner, .bwd-ratings-banner-dl-id",
    path: "bwd/content/bwd-ratings-banner/js/bwd-ratings-banner",
  }),

  bwdSeparator: BarceloComponent({
    selector: ".bwd-separator, .bwd-separator-dl-id",
    path: "bwd/content/bwd-separator/js/bwd-separator",
  }),

  bwdSlide: BarceloComponent({
    selector: ".bwd-slide, .bwd-slide-dl-id",
    path: "bwd/content/bwd-slide/js/bwd-slide",
  }),

  bwdSwiper: BarceloComponent({
    selector: ".bwd-swiper, .bwd-swiper-dl-id",
    path: "bwd/content/bwd-swiper/js/bwd-swiper",
  }),

  bwdTeaser: BarceloComponent({
    selector: ".bwd-teaser, .bwd-teaser-dl-id",
    path: "bwd/content/bwd-teaser/js/bwd-teaser",
  }),

  bwdVideo: BarceloComponent({
    selector: ".bwd-video, .bwd-video-dl-id, .c-video",
    path: "bwd/content/bwd-video/js/bwd-video",
  }),

  bwdWeddingKit: BarceloComponent({
    selector: ".bwd-wedding-kit, .bwd-wedding-kit-dl-id",
    path: "bwd/content/bwd-wedding-kit/js/bwd-wedding-kit",
  }),
};

export default AllContent;
